import { getSelectedSite, getSubDomain, handleLogout } from "@platformx/utilities";
import axiosInstance from "./restApiConfig";

export const getRequest = async (url) => {
  try {
    const res = await axiosInstance.get(process.env.NX_PUBLIC_API_URI + url, {
      headers: {
        "Content-Type": "application/json",
        "Cache-Control": "no-cache",
        sitename: getSelectedSite(),
        sitehost: getSubDomain(),
      },
      withCredentials: true,
    });
    return res?.data?.result ? res?.data?.result : res?.data;
  } catch (err: any) {
    if (err?.response?.data?.code === 401 && !url.includes("verify")) {
      handleLogout();
    }
    return err;
  }
};
export const getRequestFromDelivery = async (url) => {
  try {
    const res = await axiosInstance.get(process.env.NX_PUBLIC_PUBLISH_API_URL_GENERIC + url, {
      headers: {
        "Content-Type": "application/json",
        "Cache-Control": "no-cache",
        sitename: getSelectedSite(),
        sitehost: getSubDomain(),
      },
      withCredentials: true,
    });
    return res?.data?.result ? res?.data?.result : res?.data;
  } catch (err: any) {
    if (err?.response?.data?.code === 401 && !url.includes("verify")) {
      handleLogout();
    }
    return err;
  }
};

export const putRequest = async (url, payload) => {
  try {
    const res = await axiosInstance.put(process.env.NX_PUBLIC_API_URI + url, payload, {
      headers: {
        "Content-Type": "application/json",
        "Cache-Control": "no-cache",
        sitename: getSelectedSite(),
        sitehost: getSubDomain(),
      },
      withCredentials: true,
    });
    return res.data.result ? res.data.result : res.data;
  } catch (err: any) {
    if (err?.response?.data?.code === 401) {
      handleLogout();
    }
    return err;
  }
};

export const postRequest = async (url, payload = {}) => {
  try {
    const res = await axiosInstance.post(process.env.NX_PUBLIC_API_URI + url, payload, {
      headers: {
        "Content-Type": "application/json",
        "Cache-Control": "no-cache",
        sitename: getSelectedSite(),
        sitehost: getSubDomain(),
      },
      withCredentials: true,
    });
    return res.data.result ? res.data.result : res.data;
  } catch (err: any) {
    if (err?.response?.data?.code === 401) {
      handleLogout();
    }
    return err;
  }
};

export const commonPostApiCall = (url, payload = {}) => {
  try {
    return axiosInstance.post(url, payload, {
      headers: {
        "Content-Type": "application/json",
        "Cache-Control": "no-cache",
        sitename: getSelectedSite(),
        sitehost: getSubDomain(),
      },
    });
  } catch (err: any) {
    return err.response;
  }
};

export const commonPutApiCall = (url, payload = {}) => {
  try {
    return axiosInstance.put(url, payload, {
      headers: {
        "Content-Type": "application/json",
        "Cache-Control": "no-cache",
        sitename: getSelectedSite(),
        sitehost: getSubDomain(),
      },
    });
  } catch (err: any) {
    return err.response;
  }
};
